export default {
  methods: {
    setLoading: function (val) {
      this.$emit('admin.loading', !!val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Loading.js